import React from 'react'
import { Input } from 'antd';
const { TextArea } = Input; 

const InnerText = ({label,placeholder,onChangeValue}) => {
  
  return (
    <div className='d-flex flex-column gap-2'>
        <label>{label}</label>
        <TextArea rows={4} placeholder={placeholder} onChange={(e) => onChangeValue(e.target.value)}/>
    </div>
  )
}

export default InnerText
